<script setup lang="ts">
import { computed, defineProps } from 'vue';

const props = defineProps<{
  status: string;
  color: string;
}>();

const formattedStatus = computed<string>(() => {
  const rawStatus = props.status;
  if (!rawStatus) return '';
  return rawStatus.charAt(0) + rawStatus.slice(1).toLowerCase();
});
</script>

<template>
  <div
    class="text-nowrap d-flex align-items-center"
    :style="{ color }"
  >
    <div
      style="
        margin-right: 0.25rem;
        width: 0.25rem;
        height: 0.25rem;
        min-width: 0.25rem;
        min-height: 0.25rem;
        background-color: currentColor;
        border-radius: 100%;
      "
    ></div>

    <span style="font-size: var(--font-base); letter-spacing: -3%;">
      {{ formattedStatus }}
    </span>
  </div>
</template>
